import axios from 'axios';

const baseURL = process.env.BASE_URL;
const API = axios.create({
  baseURL: baseURL
});

API.interceptors.request.use(function(config) {
  const token = localStorage.getItem('token');
  if(token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, function(err) {
  return Promise.reject(err);
});

API.interceptors.response.use(response => {
  // renew the token
  if (response.headers.new_token) {
    localStorage.setItem('token', response.headers.new_token);
  }
  return response;
}, error => {
  if (401 === error.response.status) {
    delete localStorage.token;
    // auth.state.token = null;
    if (window.location.pathname !== '/') {
      window.location = '/';
    }
  }

  return Promise.reject(error);
});

const session = {
  login: (params) => API.post('/session/login', params),
  hasAccess: (params) => API.post('/session/has-access', params)
};

const members = {
  getFiltered: (params) => API.post('/profiles/search', params),
  export: (params) => API.post('/profiles/export', params),
  getProfilesWithChanges: (params) => API.post('/profiles/list-changes', params),
  getDetails: (params) => API.get(`/profiles/${params._id}`),
  getJobOffers: (params) => API.get(`/profiles/${params._id}/job-offers`),
  getJobOffersCounters: (params) => API.get(`/profiles/${params._id}/job-offers/counters`),
  addProfile: (params) => API.post('/profiles/', params),
  editProfile: (params) => API.put(`/profiles/${params._id}`, params),
  //getAvailableJobOffersNames: () => API.get(`/profiles/list-available-job-offers-keywords`),
  starred: (params) => API.patch(`/profiles/${params._id}/starred`, params),
  getComments: (params) => API.get(`/profiles/${params._id}/comments`),
  addComment: (params) => API.post(`/profiles/${params._id}/comments`, params),
};

const jobOffers = {
  getJobOffersStatsByJobSearchTerm: (params) => API.get('/job-offers/stats', {params}),
  getFiltered: (params) => API.get('/job-offers', {params}),
  getOne: (params) => API.get(`/job-offers/${params._id}`),
  saveSalary: (params) => API.post(`/job-offers/${params._id}/salary`, params),
  getJobOfferCounters: (params) => API.get(`/job-offers/counters`, {params}),
};

const filters = {
  getAllFilters: (params) => API.get('/saved-filters'),
  create: (params) => API.post('/saved-filters', params),
  read: (params) => API.get(`/saved-filters/${params._id}`),
  update: (params) => API.put(`/saved-filters/${params._id}`, params),
  delete: (params) => API.delete(`/saved-filters/${params._id}`),
};

const clients = {
  getRiskAverage: () => API.get('/clients/get-risk-average'),
  getEngagementAverage: () => API.get('/clients/get-engagement-average'),
  getCompanyLinkedinUrls: (params) => API.get(`/clients/${params.clientId}/linkedin-urls`),
  getCompanyQuota: (params) => API.get(`/clients/${params.clientId}/quota`),
  getSelfUser: (params) => API.get(`/clients/${params.clientId}/users/self`),
  getUsersOfAccount: (params) => API.get(`/clients/${params.clientId}/users/`),
  addUserToAccount: (params) => API.post(`/clients/${params.clientId}/users/`, params),
  updateUserStatus: (params) => API.put(`/clients/${params.clientId}/users/${params.userId}/status`, params),
  updateLogin: (params) => API.put(`/clients/${params.clientId}/users/${params.userId}`, params),
  updateSettings: (params) => API.put(`/clients/${params.clientId}/users/${params.userId}/settings`, params),
  updateNotification: (params) => API.put(`/clients/${params.clientId}/users/${params.userId}/notification`, params),
  requestChangePlan: (params) => API.post(`/clients/${params.clientId}/plan`, params),
};

const jobKeywords = {
  getListOfJobKeywordsNames: () => API.get('/job-keywords/names'),
  getListOfJobKeywordsCities: () => API.get('/job-keywords/cities'),
  searchKeywordByNameAndCity: (params) => API.get('/job-keywords/search', {params}),
  getSalaries: (params) => API.get(`/job-keywords/${params.jobKeywordId}/salaries`),
  getJobKeyword: (params) => API.get(`/job-keywords/${params.jobKeywordId}`)
}

const BO = {
  getClients: () => API.get('/admin/clients/search'),
  getAvailableSchedule: () => API.get('/admin/clients/available-schedule'),
  createClient: (params) => API.post('/admin/clients', params),
  getClient: (params) => API.get(`/admin/clients/${params.clientId}`),
  editClient: (params) => API.put(`/admin/clients/${params.client._id}`, params),
  addProfilesJson: (formData) => API.post(`/admin/clients/${formData.get('clientId')}/add-profiles-json`, formData, {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }),
  parseProcJobs: (formData) => API.post(`/admin/proc-job-offers/parse-all-results`, formData, {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }),
  getProcJobs: (params) => API.get(`/admin/proc-job-offers/list`, {params}),
  pushUrl: (params) => API.put(`/admin/proc-job-offers/${params.id}/push-url`, {params}),
  checkRidStatus: (params) => API.get(`/admin/proc-job-offers/check-rid-status/${params.rid}`),
  runParseRid: (params) => API.post(`/admin/proc-job-offers/parse-by-rid/${params.rid}`),
  getProcLin: (params) => API.get(`/admin/proc-linkedin/list`, {params}),
  pushClient: (params) => API.put(`/admin/proc-linkedin/${params.id}/push-client`, {params}),
  pushPendingClient: (params) => API.put(`/admin/proc-linkedin/${params.id}/push-pending-client`, {params}),
  stopPendingClient: (params) => API.post(`/admin/proc-linkedin/${params.id}/stop-pending-client`, {params}),
  sendEmailToClient: (params) => API.put(`/admin/proc-linkedin/${params.id}/send-email`, {params}),

}

const locations = {
  getLocations: () => API.get('/locations')
}

export default {
  session,
  members,
  filters,
  jobOffers,
  clients,
  jobKeywords,
  BO,
  locations
}



// WEBPACK FOOTER //
// ./src/api/index.js